<template>
  <div class="account-menu__content">
    <router-link-modified
      v-for="item in menu"
      :key="item.id"
      :to="{name: item.name, params: item.params}"
      class="account-menu__link base-btn base-btn--outline-dark base-btn--small _blue">
      {{ item.title }}
    </router-link-modified>
  </div>
</template>

<script>
  export default {
    name: 'AccountMenuModerator',
    data() {
      return {
        menu: [
          {
            id: 1,
            name: 'account-moderator-candidates',
            title: this.$tHeader('Candidates')
          },
          {
            id: 2,
            name: 'account-moderator-marketing',
            title: this.$tHeader('Marketing')
          },
          {
            id: 3,
            name: 'account-moderator-statistic',
            title: this.$tHeader('Statistic')
          }
        ],
      }
    }
  }
</script>

<style lang="less">

</style>
